import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import { ICustomer, SocialAccount, SocialPlatform } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
// import { sectionTypes } from "./constants";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";
import { IconBrandApple, IconBrandFacebook, IconBrandGoogle, IconEye } from "@tabler/icons-react";
import { Link, useNavigate } from 'react-router-dom';
import { Flex, ThemeIcon, Tooltip } from "@mantine/core";
import { numberWithCommas } from '../../utils/misc';

interface ICustomerRecord extends Pick<ICustomer, 'customerId' | 'email' | 'isActive' | 'isDeleted' | '_id' | 'createdAt' | 'phoneNumber' | 'socialAccounts'> {
    actions: unknown;
}

const SectionList = () => {

    const navigate = useNavigate();
    const { handleInteraction, records, deleteRecord, paginationState } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const renderSocialIcons = (value: SocialAccount[]) => {
        const icons = [];
        for (const icon of value) {
            switch (icon.platform) {
                case SocialPlatform.APPLE: {
                    icons.push(
                        <Tooltip label={icon.reference} key={icon._id}>
                            <ThemeIcon color='gray.7' key={icon._id}>
                                <IconBrandApple/>
                            </ThemeIcon>
                        </Tooltip>
                    )
                    break;
                }
                case SocialPlatform.GOOGLE: {
                    icons.push(
                        <Tooltip label={icon.reference} key={icon._id}>
                            <ThemeIcon color='green'>
                                <IconBrandGoogle size={16}/>
                            </ThemeIcon>
                        </Tooltip>
                    )
                    break;
                }
                case SocialPlatform.FACEBOOK: {
                    icons.push(
                        <Tooltip label={icon.reference} key={icon._id}>
                            <ThemeIcon color='blue'>
                                <IconBrandFacebook size={20}/>
                            </ThemeIcon>
                        </Tooltip>
                    )
                    break;
                }
                default:
                    break;
            }
        }
        return icons;
    }

    const columns: Column<ICustomerRecord>[] =  [
        {
            Header: 'Хэрэглэгчийн ID',
            accessor: 'customerId',
            Cell: ({ value, row }) => {
                return (
                    <Link to={'/customers/detail'} state={row.original._id}>
                        {value}
                    </Link>
                )
            }
        },
        {
            Header: 'И-мэйл',
            accessor: 'email',
        },
        {
            Header: 'Утас',
            accessor: 'phoneNumber',
        },
        {
            Header: 'Social',
            accessor: 'socialAccounts',
            Cell: ({ value }) => {
                return (
                    <Flex gap={3}>
                        {renderSocialIcons(value ?? [])}
                    </Flex>
                )
            }
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions
                        id={table.row.original._id}
                        deleteRecord={deleteRecord}
                        clientRoute={CLIENT_ROUTE}
                        customActions={[
                            {
                                icon: <IconEye size={18}/>,
                                onClick() {
                                    navigate('/customers/detail', { state: table.row.original._id })
                                }
                            }
                        ]}
                    />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE}: ${numberWithCommas(paginationState.totalDocuments)}`}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default SectionList;